import { ApiConnection } from 'config'


const postProducer = async (body) => {
    const {data} = await ApiConnection.post(`producer`, body)
    return data.response
}

export default postProducer